<template>
  <TextInputMultiline
    v-model="rulesTextCopy"
    :rows="6"
    :read-only="isTournamentFieldDisabled('rules_link')"
    :disabled="isTournamentFieldDisabled('rules_link')"
    has-counter
    :max-length="5000"
    :label="$t('_web_tournament_settings_rules-text-label', 'Rules text:')"
    :placeholder="
      $t(
        '_web_tournament_settings_rules-text-placeholder',
        'Provide text rules for your tournament'
      )
    "
    @lostFocus="onBlur"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TextInputMultiline from '@/components/molecules/form/TextInputMultilineWithActivators';
import { translate } from '@/mixins/translate';
const component = 'info';
export default {
  name: 'TournamentRulesTextSetting',
  inject: ['$validator'],
  components: {
    TextInputMultiline,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      rulesTextCopy: '',
    };
  },
  computed: {
    ...mapGetters([
      'currentTournament',
      'currentTournamentInfo',
      'isTournamentFieldDisabled',
    ]),
    componentData() {
      return this.currentTournamentInfo;
    },
    rulesText: {
      get() {
        return this.$lodash.get(this.componentData, 'rulesText') || '';
      },
      set(newVal) {
        //Firefox feature, it inserts line break instead of new line symbol as in Chrome
        //so we just forcing Chrome like behaviour
        let fixedBRVal = newVal.replaceAll('<br>', '\n');

        this.updateCurrentTournament({
          rulesText: fixedBRVal,
          component,
        });
      },
    },
  },
  watch: {
    'currentTournament.id'(newVal) {
      if (newVal) {
        this.initRulesText();
      }
    },
  },
  created() {
    if (this.$route.params.tournamentID) {
      this.initRulesText();
    }
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    ...mapActions(['fetchTournamentRulesText', 'errorNotify']),
    initRulesText() {
      const tournamentID =
        this.$route.params.tournamentID || this.currentTournament.id;
      if (tournamentID) {
        this.fetchTournamentRulesText(tournamentID)
          .then(response => {
            this.rulesText = response.rules;
            this.rulesTextCopy = this.rulesText;
          })
          .catch(this.errorNotify);
      }
    },
    onBlur() {
      this.rulesText = this.rulesTextCopy;
    },
  },
};
</script>
